export class Store {
    root = null;
    provider;
    constructor(provider) {
        this.provider = provider;
    }
    setRoot(root) {
        this.root = root;
    }
}
export class StoredObject {
    _store;
    constructor(store) {
        this._store = store;
    }
    setStore(store) {
        this._store = store;
    }
    get store() {
        return this._store;
    }
}
//# sourceMappingURL=store.js.map